<template>
  <md-popup
    mask
    class="p-20-0 p-0-20 door-popup"
    v-model="isVisible"
    position="bottom"
  >
    <div class="fb fb-cross-center fb-main-between">
      <span class="font-34 ff-medium">请选择</span
      ><span class="iconfont font-32 c-171A1D-40" @click="handleClose"
        >&#xe6f3;</span
      >
    </div>
    <div
      class="mt-12 bd-radio-8 p-20-0 p-0-16 fb fb-cross-center fb-main-start popup-item"
      v-for="(item, index) in cpRuleType"
      :key="`rule-${index}`"
      @click="handleGoGroup('', item.role)"
    >
      <img
        class="w-54 h-54"
        :src="require(`@/assets/images/door-${item.role}.png`)"
      />
      <span class="font-34 ff-medium pl-20">{{ item.text }}</span>
    </div>
  </md-popup>
</template>

<script>
export default {
  name: 'selectRoleType',
  mixins: [],
  props: {
    showPop: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'in'
    },
    role: {
      type: String,
      default: '1'
    }
  },
  computed: {
    cpTypeText() {
      return { in: '进', out: '出' }[this.type]
    },
    cpRuleType() {
      return [
        {
          role: 7,
          text: `为学生创建${this.cpTypeText}校规则`
        },
        {
          role: 1,
          text: `为学生家长创建${this.cpTypeText}校规则`
        },
        {
          role: 13,
          text: `为老师创建${this.cpTypeText}校规则`
        }
      ]
    }
  },
  watch: {
    showPop: {
      immediate: true,
      handler(v) {
        this.isVisible = v
      }
    }
  },
  components: {},
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    handleGoGroup(accessGroupId, role) {
      this.handleClose()
      this.$router.push({
        path: '/opendoor/group/save',
        query: {
          accessGroupId,
          role,
          type: this.type
        }
      })
    },
    handleClose() {
      this.isVisible = false
      this.$emit('close')
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.popup-item {
  width: 100%;
  height: 88px;
  background: rgba(242, 242, 246, 0.8);
}
</style>
